import { render, staticRenderFns } from "./DivUnit.vue?vue&type=template&id=0c878d99&scoped=true&"
import script from "./DivUnit.vue?vue&type=script&lang=js&"
export * from "./DivUnit.vue?vue&type=script&lang=js&"
import style0 from "./DivUnit.vue?vue&type=style&index=0&id=0c878d99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c878d99",
  null
  
)

export default component.exports